import {stage} from '../../../config/stage';

const appsyncConfig = {
    prod: {
        endpoint: 'https://b5r4bz2etzhelb6plwdpi4zboi.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
    test: {
        endpoint: 'https://6vphrvy2unexncqedid4mo3xke.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
    dev: {
        endpoint: 'https://fexfawjmtjahffc2j36ltrzddi.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
};

export const contactsAppSyncConfig = appsyncConfig[stage === 'ide' ? 'dev' : stage];
